// extracted by mini-css-extract-plugin
export var container = "support-module--container--VAs88";
export var content = "support-module--content--JKZ82";
export var selectBox = "support-module--selectBox--TAAOL";
export var form = "support-module--form--Yv6gB";